var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "details-view",
      staticStyle: { overflow: "auto", "margin-top": "100px" },
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_Settings"),
        width: "600px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "main-content",
          staticStyle: { height: "200px", overflow: "auto" }
        },
        [
          _c(
            "el-form",
            {
              staticStyle: { width: "502px", "margin-top": "10px" },
              attrs: { "label-width": "130px" }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_ApplicationScope") } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "100%",
                        display: "flex",
                        "align-items": "center"
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { "padding-left": "2px" },
                          attrs: { disabled: _vm.readonly },
                          model: {
                            value: _vm.form.useHqSet,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "useHqSet", $$v)
                            },
                            expression: "form.useHqSet"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_GeneralSettings"))
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c("div", { staticStyle: { "margin-top": "10px" } }, [
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { width: "502px" },
                    attrs: {
                      "label-width": "130px",
                      disabled: _vm.form.useHqSet && _vm.branchId !== 1
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_BasicPaymentRequest")
                        }
                      },
                      [
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "padding-left": "2px" },
                            on: { change: _vm.openCustomClick },
                            model: {
                              value: _vm.form.openUiCustom,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "openUiCustom", $$v)
                              },
                              expression: "form.openUiCustom"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_EnableUICustomization")
                              )
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_AdditionalApprovalNode")
                        }
                      },
                      [
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "padding-left": "2px" },
                            attrs: { disabled: !_vm.form.openUiCustom },
                            model: {
                              value: _vm.form.departmentApproval,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "departmentApproval", $$v)
                              },
                              expression: "form.departmentApproval"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_DepartmentApprovalTab")
                              )
                            )
                          ]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "padding-left": "2px" },
                            attrs: { disabled: !_vm.form.openUiCustom },
                            model: {
                              value: _vm.form.supervisorApproval,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "supervisorApproval", $$v)
                              },
                              expression: "form.supervisorApproval"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_SupervisorApprovalTab")
                              )
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.okHandler } },
            [_vm._v(_vm._s(_vm.$t("Message.Confirm")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }